import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';

import {setSession, getSession, delSession} from './storage'

Vue.use(Vuex);
const state = {
  profile: null,
  type: getSession('type'),//首页点击自助，赋强，存证时传过去的参数
  token:getSession('token'),
  systemConfig:{},
  signature:'',
};
const mutations = {
  SET_PROFILE: function (state, profile) {
    state.profile = profile;
  },
  SET_TOKEN:function (state,token){
    state.token = token
  },
  REMOVE_TOKEN:function (state){
    state.token = ''
  },
  SET_Type(state, data) {
    state.type = data
    setSession("type", data)
  },
  SET_SystemConfig(state,data){
    state.systemConfig=data
  },
  SET_Signature(state,data){
    state.signature = data
  }
};
const actions = {
  FedLogout({commit}) {
    // commit('SET_Type', 'zz')
    //当选择首页为存证公证时
    if(state.systemConfig.indexStyle == 4){
      commit('SET_Type', 'cz')
    }else{
      commit('SET_Type', 'zz')

    }
  },
  setSignatureNotarization({commit},data){
    console.log(commit,data)
    commit('SET_Signature',data.name)
  }
};


const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js